export default function suggestions(results, formatter, baseUrl) {
	return results.map(item => ({
		type: 'suggestions',
		className: 'autocomplete-results-list__suggestion',
		url: `${baseUrl}/search?text=${encodeURIComponent(item.term)}`,
		term: item.term,
		formattedTerm: (formatter && formatter(item.term)) || item.term,
	}));
}
